// Organization types, mirrored from server/src/config/orgTypes.js.
//
// "Firm-like" orgs refer patients out: law firms and marketers (people who
// work with several firms and always have patients to place). Marketers are
// invite-only and get exactly the law-firm experience — nav, cases,
// contacts, concierge, referrals — for free.
export const FIRM_TYPES = ['law_firm', 'marketer'];
export const isFirmLike = (type) => FIRM_TYPES.includes(type);

export const TYPE_LABELS = {
  law_firm: 'Law Firm',
  marketer: 'Marketer',
  medical_practice: 'Medical Practice',
  insurance_company: 'Insurance',
  expert_service: 'Expert Service',
  other: 'Other',
};
export const TYPE_COLORS = {
  law_firm: '#F59E0B',
  marketer: '#8B5CF6',
  medical_practice: '#10B981',
  insurance_company: '#3B82F6',
  expert_service: '#223368',
};
